export default {
  addressRemoved: 'آدرس حذف شد',
  addressUpdated: 'آدرس به روز رسانی شد',
  addressAdded: 'آدرس افزوده شد',
  address: 'آدرس',
}
